export class BlockVehicleGrid {
  /**
   * All DOM Nodes required to run the application
   *
   * @type {{buttons: {loadMore: null, filters: []}, postList: null, wrapper: null}}
   * @private
   */
  _dom = {
    wrapper: null,
    filterBtn: null,
    submitBtn: null,
    loadMoreBtn: null,
    sortSelect: null,
    closedDrawerBtn: null,
    priceSlider: {
      container: null,
      slider: null,
      minInput: null,
      maxInput: null,
      summary: null,
      noUiSliderInstance: null,
    },
  };

  _state = {
    lastFilters: null,
  };

  constructor(wrapper) {
    if (!wrapper) {
      return;
    }

    if (typeof FWP === "undefined") {
      console.error("FacetWP not found");
      return;
    }

    this._dom.wrapper = wrapper;

    this._dom.filterBtn = this._dom.wrapper.querySelector("button.filter");
    this._dom.loadMoreBtn =
      this._dom.wrapper.querySelector(".facetwp-load-more");
    this._dom.sortSelect =
      this._dom.wrapper.querySelector(".facetwp-type-sort");
    this._dom.priceSlider.container = this._dom.wrapper.querySelector(
      ".facetwp-slider-container"
    );
    this._dom.priceSlider.summary = this._dom.wrapper.querySelector(
      ".price-slider-summary"
    );
    this._dom.closedDrawerBtn =
      this._dom.wrapper.querySelector(".--close-drawer");

    this._dom.submitBtn = this._dom.wrapper.querySelector(
      ".b-vehicles-teaser__filters__submit"
    );

    document.addEventListener("facetwp-loaded", () => {
      FWP.auto_refresh = false;
      this._state.lastFilters = FWP.facets;
      this.handlePriceSliderFilter();
      this.handleLoadMore();
      this.handleSort();
      this.handleFilterDrawer();
      this.handleTotals();
      this.handleManufacturerMoreBtn();
      this.addListenersInputs();
    });

    this.addListenersButtons();
  }

  checkIsDirty() {
    FWP.parseFacets();

    const isDirty = Object.keys(FWP.facets).some((key) => {
      const currentFacet = FWP.facets[key];
      const lastFacet = this._state.lastFilters[key];

      if (!lastFacet) {
        return true;
      }

      if (currentFacet.length !== lastFacet.length) {
        return true;
      }

      return currentFacet.some((item) => !lastFacet.includes(item));
    });

    return isDirty;
  }

  checkTotal() {
    if (!this.checkIsDirty()) {
      this._dom.submitBtn.classList.add("--disabled");
      const submitBtnText = this._dom.submitBtn.querySelector("span");
      submitBtnText.innerHTML = "";
      return;
    }

    const endpoint = "wp" === FWP.template ? document.URL : FWP_JSON.ajaxurl;
    const data = {
      action: "facetwp_refresh",
      data: FWP.buildPostData(),
    };

    jQuery
      .post(endpoint, data)
      .success((response) => {
        if (!response || !response.settings) {
          return;
        }

        const totalPosts = response.settings.pager.total_rows;
        if (totalPosts == 0) {
          this._dom.submitBtn.classList.add("--disabled");
        } else {
          this._dom.submitBtn.classList.remove("--disabled");
        }

        const submitBtnText = this._dom.submitBtn.querySelector("span");
        const totalText = submitBtnText.dataset.text;
        submitBtnText.innerHTML = totalText.replace("%s", totalPosts);
      })
      .fail((err) => {
        console.error(err);
      })
      .always(() => {
        this._dom.wrapper
          .querySelectorAll(".facetwp-slider")
          .forEach((slider) => {
            slider.removeAttribute("disabled");
          });
      });
  }

  addListenersInputs() {
    jQuery(document).on(
      "click",
      ".facetwp-checkbox:not(.disabled), .facetwp-radio:not(.disabled)",
      (e) => {
        this.checkTotal();
      }
    );
  }

  addListenersButtons() {
    this._dom.submitBtn.addEventListener("click", () => {
      this.refreshFilters();
    });

    const buttonManufacturers = this._dom.wrapper.querySelector(
      ".show-all-manufacturers"
    );
    const buttonEnergy = this._dom.wrapper.querySelector(
      ".--energy_efficiency_class__title"
    );
    const backButton = this._dom.wrapper.querySelector(".--back");

    if (buttonManufacturers) {
      buttonManufacturers.addEventListener("click", () => {
        this.openManufactureSection();
      });
    }

    if (buttonEnergy && window.innerWidth < 1024) {
      buttonEnergy.addEventListener("click", () => {
        this.handleMobileTaxonomySection("energy_efficiency_class", true);
      });
    }

    if (backButton) {
      backButton.addEventListener("click", () => {
        this.handleMobileTaxonomySection("manufacturer", false);
      });
    }
  }

  handleManufacturerMoreBtn() {
    const count = this._dom.wrapper.querySelectorAll(
      ".manufacturers .facetwp-checkbox"
    ).length;

    const button = this._dom.wrapper.querySelector(".show-all-manufacturers");

    if (!button || !count) {
      return;
    }

    if (count < 6) {
      button.classList.remove("--active");
    } else {
      button.classList.add("--active");
    }
  }

  handleTotals() {
    if (!FWP.facets) {
      return;
    }
    Object.keys(FWP.facets).forEach((facet) => {
      const count = FWP.facets[facet].length;

      const element = this._dom.wrapper.querySelector(`.${facet} .--total`);

      if (!element) {
        return;
      }

      this._dom.wrapper.querySelector(`.${facet} .--total`).innerHTML = count
        ? ` (${count})`
        : "";
    });
  }

  handleLoadMore() {
    if (!this._dom.loadMoreBtn) {
      return;
    }

    const hasMorePages =
      FWP.settings.pager.page < FWP.settings.pager.total_pages;

    this._dom.loadMoreBtn.disabled = !hasMorePages;

    if (!hasMorePages) {
      this._dom.loadMoreBtn.classList.add("facetwp-hidden");
    } else {
      this._dom.loadMoreBtn.classList.remove("facetwp-hidden");
    }
  }

  handleSort() {
    if (
      typeof fSelect === "undefined" ||
      !this._dom.sortSelect ||
      this._dom.sortSelect.querySelector(".fs-wrap")
    ) {
      return;
    }

    fSelect(this._dom.sortSelect.querySelector("select"));

    if (this.isEmpty(this._dom.sortSelect.querySelector("select").value)) {
      this._dom.sortSelect.classList.add("fs-select-empty");
    }

    this._dom.sortSelect.classList.add("fs-select-initialized");

    this._dom.sortSelect
      .querySelector("select")
      .addEventListener("change", (e) => {
        if (this.isEmpty(e.target.value)) {
          this._dom.sortSelect.classList.add("fs-select-empty");
        } else {
          this._dom.sortSelect.classList.remove("fs-select-empty");
        }

        this.refreshFilters();
      });
  }

  handlePriceSliderFilter() {
    if (!this._dom.priceSlider.container) return;

    this._dom.priceSlider.slider =
      this._dom.priceSlider.container.querySelector(".facetwp-slider");
    this._dom.priceSlider.minInput =
      this._dom.priceSlider.container.querySelector(".--min");
    this._dom.priceSlider.maxInput =
      this._dom.priceSlider.container.querySelector(".--max");
    this._dom.priceSlider.noUiSliderInstance =
      this._dom.priceSlider.slider.noUiSlider;

    this._dom.priceSlider.noUiSliderInstance.off();

    this._dom.priceSlider.noUiSliderInstance.on(
      "update",
      this.updateInputsFromSlider.bind(this)
    );
    this._dom.priceSlider.noUiSliderInstance.on("end", () => {
      this.checkTotal();
    });

    // Remove old listeners
    this._dom.priceSlider.minInput.removeEventListener(
      "blur",
      this._boundUpdateSliderFromInputs
    );

    this._dom.priceSlider.maxInput.removeEventListener(
      "blur",
      this._boundUpdateSliderFromInputs
    );

    // Add new listeners
    this._dom.priceSlider.minInput.addEventListener(
      "blur",
      this.updateSliderFromInputs.bind(this)
    );
    this._dom.priceSlider.maxInput.addEventListener(
      "blur",
      this.updateSliderFromInputs.bind(this)
    );

    this.updateInputsFromSlider(false);
  }

  handleFilterDrawer() {
    if (!this._dom.filterBtn) {
      return;
    }

    this._dom.filterBtn.addEventListener("click", () =>
      this.changeModalStatus(true)
    );

    this._dom.closedDrawerBtn.addEventListener("click", () =>
      this.changeModalStatus(false)
    );

    this._dom.wrapper
      .querySelector(".facetwp-reset")
      .addEventListener("click", () => this.changeModalStatus(false));
  }

  updateInputsFromSlider() {
    const values = this._dom.priceSlider.noUiSliderInstance.get();
    this._dom.priceSlider.minInput.value = Math.round(values[0]);
    this._dom.priceSlider.maxInput.value = Math.round(values[1]);

    const currency = this._dom.priceSlider.summary.dataset.currency;
    this._dom.priceSlider.summary.innerHTML = `${Math.round(
      values[0]
    )}${currency} - ${Math.round(values[1])}${currency}`;
  }

  updateSliderFromInputs() {
    const minVal = parseInt(this._dom.priceSlider.minInput.value, 10) || null;
    const maxVal = parseInt(this._dom.priceSlider.maxInput.value, 10) || null;

    this._dom.priceSlider.noUiSliderInstance.set([minVal, maxVal]);

    this.checkTotal();
  }

  isEmpty(value) {
    return !value || 0 === value.length;
  }

  changeModalStatus(open) {
    if (open) {
      document.body.classList.add("filter-drawer-open");
    } else {
      document.body.classList.remove("filter-drawer-open");
    }
  }

  openManufactureSection() {
    this.handleMobileTaxonomySection("manufacturer", true);

    const options = this._dom.wrapper
      .querySelector(
        ".b-vehicles-teaser__filters__content__options.--manufacturer"
      )
      .querySelector(".facetwp-type-checkboxes");

    let items = [];

    [...options.children].forEach((child) => {
      const text = child.querySelector(".facetwp-display-value");
      const firstLetter = text?.innerHTML.charAt(0).toUpperCase();
      if (firstLetter) {
        if (!items[firstLetter]) {
          items[firstLetter] = [];
        }
        items[firstLetter].push(child);
      }
    });

    const sortedKeys = Object.keys(items).sort();

    let newHtml = "";
    sortedKeys.forEach((letter) => {
      newHtml += `<strong>${letter}</strong>`;
      items[letter].forEach((label) => {
        newHtml += label.outerHTML;
      });
    });

    options.innerHTML = newHtml;
  }

  handleMobileTaxonomySection(taxonomy, open = true) {
    const wrapper = this._dom.wrapper.querySelector(
      ".b-vehicles-teaser__filters__content--wrapper"
    );
    const section = this._dom.wrapper.querySelector(
      `.b-vehicles-teaser__filters__content__options.--${taxonomy}`
    );
    const header = this._dom.wrapper.querySelector(
      ".b-vehicles-teaser__filters__content__header"
    );
    const headerTitle = header.querySelector(".--title");

    let titleText = headerTitle.dataset.title;
    if (open) {
      const title = this._dom.wrapper.querySelector(
        `.c-accordion__row.--${taxonomy} .${taxonomy}`
      );
      titleText = title.innerHTML;
    }

    headerTitle.innerHTML = titleText;

    if (open) {
      header.classList.add("--active");
      section.classList.add("--active");
      wrapper.style.transform = "translateX(-100%)";
      this._dom.wrapper
        .querySelector(".b-vehicles-teaser__filters__content")
        .scrollTo(0, 0);
    } else {
      wrapper.style.transform = "translateX(0)";
      header.classList.remove("--active");
      section.classList.remove("--active");
    }
  }

  refreshFilters() {
    this._dom.submitBtn.classList.add("--disabled");
    const submitBtnText = this._dom.submitBtn.querySelector("span");
    submitBtnText.innerHTML = "";
    this.changeModalStatus(false);
    FWP.auto_refresh = true;
    FWP.autoload();
    FWP.auto_refresh = false;
  }
}
